module.exports = __webpack_public_path__ + "static/media/creator-GradientWaveLines.ae46dc86.png";